import { combineReducers } from "redux";

import theme from "./themeReducer";
import layout from "./layoutReducer";
import sidebar from "./sidebarReducer";

import user from "./userReducer";
import admin from "./adminReducer";
import campaigns from "./campaignReducer";
import datasets from "./datasetReducer";
import services from "./serviceReducer";

import { reducer as toastr } from "react-redux-toastr";
import { USER_DESIRED_PAGE } from "../constants";

const appReducers = combineReducers({
  user,
  admin,
  campaigns,
  datasets,
  sidebar,
  layout,
  theme,
  toastr,
  services
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    // Force reducers to reload from initialStates
    state = undefined;
    sessionStorage.removeItem(USER_DESIRED_PAGE);
  }

  return appReducers(state, action);
};

export default rootReducer;
